/* eslint-disable no-alert */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// import { post } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import * as url from '../../helpers/url_helper';
import { post } from '../../helpers/api_helper';

function Directory(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [signal, setSignal] = useState(0);

  const deleteEntity = async (entity, e) => {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    // eslint-disable-next-line no-restricted-globals
    const cnfrm = confirm(props.t(`Are you sure you want to delete ${entity.name}?`));

    if (cnfrm) {
      try {
        await post(url.DELETE_DIRECTORY_ENTRY, { id: entity.id });

        toastr.success(props.t(`Deleted entity ID: ${entity.id}`), props.t('Success'));
        setSignal(signal + 1);
      } catch (error) {
        toastr.error(error.message, props.t('Error'));
      } finally {
        btn.disabled = false;
        btn.firstChild.classList.toggle('bx-spin');
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Directory')}</CardTitle>

                <Can i="see" this="Directory">
                  <BaseGrid
                    url={url.GET_DIRECTORY_ENTRIES}
                    shouldUpdate={signal}
                    create="/directory/create"
                    className="table table-sm table-hover table-bordered fs-6"
                    hasSearch
                    config={
                    {
                      columns: {
                        id: {
                          label: props.t('ID'),
                          sort: true,
                          link: {
                            to: '/directory/entry/%id%',
                          },
                        },
                        name: {
                          label: props.t('Name'),
                          sort: true,
                          link: {
                            to: '/directory/entry/%id%',
                          },
                        },
                        email: {
                          label: props.t('Email'),
                          sort: true,
                          link: {
                            to: '/directory/entry/%id%',
                          },
                        },
                        company: { label: props.t('Company'), sort: true },
                        phone: { label: props.t('Phone'), sort: true },
                        notes: { label: props.t('Notes'), sort: true },
                        created_at: {
                          label: props.t('Created'),
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                          sort: true,
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteEntity,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Users"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Directory.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Directory));
